// removed by extract-text-webpack-plugin
module.exports = {"no-results-container":"no-results-container___1hQRQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/NoResults.scss
// module id = E6Dt
// module chunks = 57